var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"width":"400"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',_vm._l((_vm.delivOrders),function(item,index){return _c('div',{key:index},[_c('Cell',{attrs:{"delivOrder":item}})],1)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }